<div class="msd-wrapper" (keydown.escape)="cerrar()">
  @if (label()) {
    <label class="form-label">{{ label() }}</label>
  }

  <input type="text"
         class="form-control msd-toggle"
         [disabled]="deshabilitado()"
         [attr.aria-expanded]="abierto()"
         aria-haspopup="listbox"
         autocomplete="off"
         [placeholder]="textoResumen()"
         [value]="busqueda()"
         (focus)="abrir()"
         (input)="busqueda.set($any($event.target).value)">

  @if (abierto()) {
    <div class="msd-panel" role="group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [id]="idBase + '-todos'"
               [checked]="todos()" [disabled]="deshabilitado()"
               (change)="onTodosChange($any($event.target).checked)">
        <label class="form-check-label" [for]="idBase + '-todos'">Todos</label>
      </div>
      @for (o of opcionesFiltradas(); track o.id) {
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [id]="idBase + '-opcion-' + o.id"
                 [checked]="seleccionados().includes(o.id)" [disabled]="deshabilitado()"
                 (change)="onOpcionToggle(o.id, $any($event.target).checked)">
          <label class="form-check-label" [for]="idBase + '-opcion-' + o.id">{{ o.nombre }}</label>
        </div>
      } @empty {
        <div class="form-text">Sin resultados.</div>
      }
    </div>
  }
</div>
